import ViewFactory from "../../../helpers/viewfactory";

export default function view() {
        return (view = ViewFactory({
            NAME: 'CAPITEC_CONFIRM_VIEW',
            mutables: { timerCurrent: 'CURRENT_TIME', instruction: 'CAPITEC_INSTRUCTION' },
            constant: {
                hasBackAction: false,
                get timerDuration() { return $timer.duration }
            }
        }).call(this)
    )
}